import {NgModule} from '@angular/core'
import {BottomNavigationModule} from '../../../craft/bottom-navigation/bottom-navigation.module'
import {TranslocoModule} from '@ngneat/transloco'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {RouterModule} from '@angular/router'
import {PipesModule} from '../../pipes/pipes.module'
import {AsyncPipe, NgIf} from '@angular/common'
import {StickyBottomNavigationComponent} from './sticky-bottom-navigation/sticky-bottom-navigation.component'
import {ButtonModule} from '../../../craft/button/button.module'

@NgModule({
  declarations: [StickyBottomNavigationComponent],
  imports: [
    RouterModule,
    BottomNavigationModule,
    TranslocoModule,
    FontAwesomeModule,
    PipesModule,
    NgIf,
    AsyncPipe,
    ButtonModule,
  ],
  exports: [StickyBottomNavigationComponent],
})
export class StickyBottomNavigationModule {}
